/** Member CTA label for locked pattern tease surfaces. */
export const LOCKED_PATTERN_MEMBER_CTA = "Become a member";

/**
 * Build the personalized locked-pattern tease line.
 * @param {number} loopCount
 * @param {number} interpretationCount
 * @param {number} totalReflections
 */
export function formatLockedPatternTeaseMessage(loopCount, interpretationCount, totalReflections) {
  const loopLabel = loopCount === 1 ? "loop" : "loops";
  const interpretationLabel = interpretationCount === 1 ? "interpretation" : "interpretations";
  const reflectionLabel = totalReflections === 1 ? "reflection" : "reflections";
  return `We've detected ${loopCount} repeating ${loopLabel} and ${interpretationCount} recurring ${interpretationLabel} in your ${totalReflections} ${reflectionLabel} — become a Member to see them.`;
}
